const fromPlaceByIdQueryToPlaceById = (data)=>{
    if (!data) {
        return null;
    }
    const { coordinates: { lat , lon  } ,  } = data;
    return {
        coordinates: {
            lat,
            lon
        }
    };
};
var fromPlaceByIdQueryToPlaceById$1 = fromPlaceByIdQueryToPlaceById;

export { fromPlaceByIdQueryToPlaceById$1 as default };
//# sourceMappingURL=fromPlaceByIdQueryToPlaceById.js.map
